// extracted by mini-css-extract-plugin
export default {"btn":"styles_btn__jSc25","btn_exclamation":"styles_btn_exclamation__o4pmx"};